import Vue from 'vue';
import { VueHammer } from 'vue2-hammer';

VueHammer.config.swipe = {
  direction: 6,
};

Vue.use(VueHammer);
